ko.components.register('pbn-status-toggle', {
	viewModel: function(params) {
		var self = this;

		self.element = false;
		self.tip = false;
		self.showAll = ko.observable(false);
		self.showDetails = ko.observable(false);

		self.detailsTitle = ko.observable(params && params.detailsTitle || 'Show By Status');
		self.showLabel = ko.observable(params && params.showLabel || 'Show All');
		self.hideLabel = ko.observable(params && params.hideLabel || 'Hide');

		self.values = ko.observable();
		self.hidden = ko.observable();

		self.setData = function(data) {
			self.values((data && data.values) || window._pbn['status']);
			self.hidden((data && data.hidden) || window._pbn['status_hidden']);

			self.updateVisibility();
		};

		// methods

		self.getLabel = ko.pureComputed(function() {
			if(self.showAll())
				return self.hideLabel();
			return self.showLabel();
		});

		self.hasHidden = ko.pureComputed(function() {
			return Object.keys(self.hidden()).length > 0;
		});

		self.getValues = ko.pureComputed(function() {
			const v = self.values();
			if(!v) return [];
			return Object.keys(v).map(function (k) {
				return {
					'value': k,
					'label': v[k]
				};
			});
		});

		self.downloadFile = function(blob, fileName) {
			const link = document.createElement('a');
			const url = window.URL || window.webkitURL;
			// create a blobURI pointing to our Blob
			link.href = url.createObjectURL(blob);
			link.download = fileName;
			// some browser needs the anchor to be in the doc
			document.body.append(link);
			link.click();
			link.remove();
			// in case the Blob uses a lot of memory
			setTimeout(() => url.revokeObjectURL(link.href), 7000);
		};

		self.exportData = function() {
			const date = new Date();
			const d = date.getDate();
			const m = date.getMonth() + 1;
			const y = date.getFullYear();

			var items = [];
			$('tr:visible td.pbn-domain-name a').each(function(i, item){
				const $tr = $(item).closest('tr');
				const k = $tr.find('.pbn-keywords-type .pbn-domain-field').text() || "";
				const d = $tr.find('.pbn-went-live-date').data('date-value') || "";
				items.push($(item).text() + ';"' + k.replaceAll('"', '\"') + '";' + d);
			});
			self.downloadFile(new Blob([items.join("\r\n")]), "pbn_"
				+ (y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d) + '_' + date.getHours() + 'h' + date.getMinutes())
				+ ".csv");
		};

		self.updateRowsNumbers = function() {
			$('.pbn-row:visible .row-num').each(function(i, item) { $(item).text(i + 1); });
		};

		self.updateVisibility = function() {
			const state = self.showAll();
			var total = 0;
			for(var k in self.values()) {
				const $e = $('.pbn-status-' + k);
				if(state || Object.keys(self.hidden()).indexOf(k) === -1) {
					$e.show();
					total++;
				} else {
					$e.hide();
				}
			}
			$('.pbn-total-rows').text($('.pbn-row:visible').length);
			self.updateRowsNumbers();
		};

		self.toggle = function(data, event) {
			self.showAll(!self.showAll());
			self.updateVisibility();
		};

		self.getIsHidden = function(data) {
			return Object.keys(self.hidden()).indexOf(data.value) !== -1;
		};

		self.toggleValue = function(data, event) {
			const v = data.value;
			var tmp = self.hidden();
			if(Object.keys(tmp).indexOf(v) !== -1) {
				delete tmp[v];
				$(event.target).removeClass('active');
			} else {
				tmp[v] = self.values()[v];
				$(event.target).addClass('active');
			}
			self.hidden(tmp);
			self.updateVisibility();
		};

		self.toggleDetails = function(data, event) {
			self.showDetails(!self.showDetails());

			if(!self.showDetails()) {
				self.tip
					.stop()
					.animate({left: '15px', opacity: 0}, 200, function() {
						self.element.removeClass('active');
						self.element.popover('hide');
						self.tip.css({left: -1000});
					});
			} else {
				if(!self.element)
					self.element = $(event.target);
				if(!self.element.data('bs.popover')) {
					var $details = $('#pbn-status-toggle-details');
					self.element.popover({
						animation: false,
						placement: 'right',
						html: true,
						content: $details
					});
					$details.show();
					self.tip = $(self.element.data('bs.popover').getTipElement());
				}

				self.element.addClass('active');
				self.element.popover('show');

				self.tip
					.stop()
					.css({left: '15px', opacity: 0})
					.animate({left: 0, opacity: 1}, 200);
			}
		};

		self.setData(params.data || {});
	},
	template: "<div class=\"pbn-status-toggle\">\n\t<button class=\"btn btn-link text-muted\" data-bind=\"click: exportData\"><span class=\"ic ic-download\"></span></button>\n\t<button class=\"btn btn-link\" data-bind=\"css: { 'text-muted': hasHidden() }, click: toggleDetails\"><span class=\"ic ic-cog\"></span></button>\n\t<button class=\"btn btn-outline-secondary\" data-bind=\"visible: hasHidden, html: getLabel, click: toggle\"></button>\n</div>\n\n<div style=\"display:none;min-width:200px\" data-bind=\"attr: { 'id': 'pbn-status-toggle-details'}\">\n\t<button data-bind=\"click: toggleDetails\" class=\"close\">&times;</button>\n\t<h5 class=\"pbn-status-toggle-header\">\n\t\t<span data-bind=\"text: detailsTitle\"></span>\n\t</h5>\n\t<div class=\"pbn-status-toggle-body\">\n\t\t<div data-bind=\"foreach: getValues\">\n\t\t\t<div class=\"pbn-status-toggle-item\" data-bind=\"text: label, css: { 'active': !$component.getIsHidden($data) }, click: $component.toggleValue\"></div>\n\t\t</div>\n\t</div>\n</div>"
});